import { FormControl, ListSubheader, MenuItem, Select, Typography } from "@mui/material";
import { styles } from "./styles";
import { useSearch } from "../../../hooks/seach/useSearch";

export default function Area() {

    const {
        area, setArea,
        listAreas,
    } = useSearch();

    return (
        <>
            <Typography style={styles.labelInput}>
                Tipo de Ocorrência: *
            </Typography>

            <FormControl variant="outlined" style={styles.formControl}>
                <Select
                    onChange={e => setArea(e.target.value)}
                    value={area}
                    style={{ 'background': '#fff' }}
                >
                    <MenuItem value="Todos">Todos</MenuItem>

                    {listAreas.map((res, index) => {
                        let components = [];
                        if (index === 0 || listAreas[index - 1].groupId !== res.groupId)
                            components.push(<ListSubheader>{res.group?.nameSecretary}</ListSubheader>)

                        components.push(<MenuItem value={res.name} key={res.name} sx={{ marginLeft: 2 }}>
                            {res.name}
                        </MenuItem>)

                        return components;
                    })}
                </Select>
            </FormControl>
        </>
    );
}
